<template>
    <div class="all clearfix">
        <Myleft ref="left"></Myleft>
        <div class="mdCont fl bgff w750 ml10">
           <div class="grid pb30">
               <h2 class="fs16">标签：<strong>{{title}}</strong></h2>
                <div class="screen mt20">
                    <div class="item clearfix">
                        <span class="zu clearfix">
                            <span class="name">地区</span>
                            <city @cityCallback="citySelect" ref="city"></city>
                        </span>
                        
                        <span class="zu yujin-text clearfix">
                            <span class="name">时间</span>
                            <span class="drop-down">
                                <vue-datepicker-local ref="timeSelect" v-model="timeRange" format="YYYY-MM-DD" :disabled-date="disabledDate"  show-buttons clearable @clear="selectedDate" @confirm="selectedDate" placeholder="请选择时间"/>
                            </span>
                        </span>
                    </div>
                </div>
                <div class="warp mt5 clearfix">
                    <div class="warp-body mh270">
                        <div class="no-data" v-if="nodata.hotList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                        <ul class="article-list">
                            <li class="imgText clearfix" v-for="(item,index) in hotList" :key="index">
                                <router-link class="img fl cp" :to="{path:'eventDetail',query:{id:item.id}}" target="_blank"><img :src="item.icon" :onerror="defaultImg"/></router-link>
                                <div class="hidden">
                                    <div class="clearfix mt5">
                                        <span class="fr">舆情指数 <strong class="cr27 fs18">{{item.exponent}}</strong></span>
                                        <h2 class="fl ovhidden">
                                            <router-link class="cr00 cp" :to="{path:'eventDetail',query:{id:item.id}}" target="_blank">{{item.name}}</router-link>
                                        </h2>
                                    </div>
                                    <p class="cr5e mt10 ovhidden2">{{item.schemeDescription}}</p>
                                    <p class="ziduan mt15 cr77">
                                        <a class="tag tag-blue fr" href="javascript:void(0);">{{tagsList[item.typeId]}}</a>　
                                        <span v-if="item.news_source!=''">{{item.news_source}} ·  </span>
                                        <span>{{timeFilter(item.createTime)}}</span>
                                    </p>
                                </div>
                            </li>
                            
                        </ul>
                        <div class="mt20 ac" v-if="isShowMore">
                            <a class="btnMmore color-8a8a99" href="javascript:void(0);" @click="showMore">加载更多</a>
                        </div>
                        <div class="mt20 ac" v-if="isShowEnd">
                            <a class="more color-8a8a99" href="javascript:void(0);">数据已经全部加载完成啦~</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="mrCont w310 bgff fr">
            <div class="grid">
                <div class="grid-body">
                    <ul class="jzNews mb20">
                        <ul class="event">
                            <li v-for="(item,index) in hotTopicsList" :key="index">
                                <router-link class="img" :to="{path:'eventTag',query:{id:item.id,type:item.name}}">
                                    <img class="img db" :src="[item.icon]" :onerror="defaultImg"/>
                                    <span class="name ac db">{{item.name}}</span>
                                </router-link>
                            </li>
                        </ul>
                        <div class="no-data pt30" v-if="nodata.hotTopicsList"><img src="static/images/no_data.png" class="img"/><span class="text">没有数据哦...</span></div>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Myleft from '../../components/left'
import city from '../../components/city.vue';
import VueDatepickerLocal from 'vue-datepicker-local';
export default {
    components: {Myleft,VueDatepickerLocal,city},
    data() {
        return {
            sid : this.$route.query.id,
            title : this.$route.query.type,
            hotTopicsList:[],
            defaultImg:'this.src="static/images/default.png"',
            tags:'全部',
            tagsList:[],
            hotList:[],
            pageCur:1,
            pageNum:6,
            dataCount:0,
            timeRange: [],
            startTime:null,
            endTime:null,
            province:'',//省份
            city:'',//城市
            isShowMore:false,
            isShowEnd:false,
            nodata:{
                hotTopicsList:false,
                hotList:false
            }
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.tags = that.$route.query.type;
            that.initialTime();
            that.sortAjax();
            that.dataAjax();
            that.hotListAjax();
        }) 
    },
    watch: {
		$route(){
			let that = this;
            that.title = that.$route.query.type;
            that.$refs.left.curType = that.title;
            that.clearAllData();
		},
	},
    methods: {
        clearAllData(){
            let that =this;
            that.startTime=null;
            that.endTime=null;
            that.province='';
            that.city='';
            that.timeRange=[];
            that.$refs.city.fullName = '';
            that.clearListData();
            that.sortAjax();
            // that.dataAjax();
        },
        // 获取当前时间和7天前时间
        initialTime() {
            let max = '';
            let min = '';
            let nowTime = this.$utils.getNowDate();
            let n = nowTime.split(' ');
            let n1 = n[0].split('-');
            let n2 = n[1].split(':');
            let oldTime = this.$utils.getBeforeDay(nowTime,7);
            let o = oldTime.split('-');
            max = new Date(n1[0], n1[1]-1, n1[2])
            min = new Date(o[0], o[1]-1, o[2])
            this.timeRange = [min,max];
            //进页面获取时间数据
            this.startDate = this.$utils.dateConversion(min,1);
            this.endDate = this.$utils.dateConversion(max,1);
        },
        dataAjax(){
            let that = this;
            that.$api.get('hotnews/index/tag-list-right',null,r=>{
                that.$parent.returnCode(r,function(){
                    that.hotTopicsList = r.data;
                    if(r.data.list.length<=0){
                        that.nodata.hotTopicsList = true;
                    }else{
                        that.nodata.hotTopicsList = false;
                    }
                    
                });
            });
        },
        sortAjax(){//分类
			let that = this;
            that.$api.get('hotnews/index/hot-news-type',null,r=>{
                that.$parent.returnCode(r,function(){
					that.tagsList = r.data;
               })
            })
		},
        // 地区筛选
        citySelect (name) {
            let province = name[3];
            let city = name[2];
            let that = this;
            if(province === '全国'){
                that.province = '';
            }else{
                that.province = province;
            }
            that.city = (city === '全市'|| city === '全省' || city === '选择城市')?'':city;
            that.clearListData();
        },
        hotListAjax(){
            let that = this;
            let tags = (that.tags == '全部')?'':that.tags;
            let datas={
                //type:'',
                tag:that.title,
                startTime:that.startTime,
                endTime:that.endTime,
                province:that.province,
                city:that.city,
                perpage:that.pageNum,
                page:that.pageCur
            };
            that.$parent.loadModal(true,'数据加载中...');
            that.$api.get('hotnews/hot-news/list',datas,r=>{
                that.$parent.returnCode(r,function(){
                    that.$parent.loadModal(false);
                    if(r.data.list.length<=0){
                        if(that.pageCur==1){
                            that.nodata.hotList = true;
                            return
                        }
                        that.isShowMore = false;
                        that.isShowEnd = true;
                        return
                    }else{
                        that.nodata.hotList = false;
                        that.isShowMore = true;
                    }
                    that.hotList = that.hotList.concat(r.data.list);
                });
            });
        },
        showMore(){
            let that = this;
            that.pageCur++;
            that.hotListAjax();
        },
        clearListData(){
            let that = this;
            that.isShowMore = false;
            that.isShowEnd = false;
            that.pageCur = 1;
            that.hotList = [];
            that.hotListAjax()
        },
        disabledDate (time) {
            //return time < this.min || time > this.max
        },
        selectedDate (date) {
            let that = this;
            if(date == undefined){
                that.startTime = '';
                that.endTime = '';  
            }else{
                that.startTime = that.$utils.dateConversion(that.timeRange[0],1);
                that.endTime = that.$utils.dateConversion(that.timeRange[1],1);
            }
            that.clearListData();
        },
        timeFilter(t){
            var newT = '';
            if(t!=null){
                let tmp = t.split(' ')[0].split('-');
                newT = tmp[0]+'年'+tmp[1]+'月'+tmp[2]+'日';
                return newT;
            }
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/event/eventTag.vue